export const SNACK_TYPE = Object.freeze({
  text: 'text',
  action: 'action',
  longAction: 'longAction',
  desicion: 'desicion',
});
